/**
 * @module Environment
 * @description This module manages the environment variables for the application.
 */
import { App } from 'src/types/app';
import {
  DistributionPlatform,
  Environment,
  Region,
  RepoBackend,
} from 'src/types/env';
import { getEnumValue } from 'src/utils/enum_utils';

export function getEnvironment() {
  return getEnumValue(Environment, import.meta.env.VITE_ENV);
}

export function getApp() {
  return getEnumValue(App, import.meta.env.VITE_APP);
}

export function getPlatform(): DistributionPlatform {
  const app = getApp();
  if (app === App.Ldt) {
    return DistributionPlatform.Ldt;
  }
  if (
    app === App.SamdUs ||
    app === App.SamdEu ||
    app === App.SamdUk ||
    app === App.SamdDemo
  ) {
    return DistributionPlatform.Samd;
  }
  throw new Error(`Unsupported app for platform: ${app}`);
}

export function getRegion(): Region {
  const app = getApp();
  if (app === App.SamdEu) {
    return Region.EU;
  }
  if (app === App.SamdUk) {
    return Region.UK;
  }
  if (app === App.Ldt || app === App.SamdUs || app === App.SamdDemo) {
    return Region.US;
  }
  throw new Error(`Unsupported app for region: ${app}`);
}

// TODO(joshm): Refactor this later similar to above.
export function getRepoBackend() {
  return getEnumValue(
    RepoBackend,
    import.meta.env.VITE_IS_FAKE_BACKEND === 'true'
      ? RepoBackend.Fake
      : RepoBackend.Real,
  );
}
